import { useEffect} from 'react'
import ResizeObserverPolyfill from 'resize-observer-polyfill'
import useEventCallback from './useEventCallback'







const ResizeObserver = window.ResizeObserver || (ResizeObserverPolyfill )

const useResizeObserver = (
  cb,
  ref
) => {
  const eventCb = useEventCallback(cb)
  useEffect(() => {
    if (!ref || !ref.current) return
    const resizeObserver = new ResizeObserver(eventCb)
    resizeObserver.observe(ref.current)
    return () => {
      resizeObserver.disconnect()
    }
  }, [ref, eventCb])
}

export default useResizeObserver
